<template lang="html">
  <div class="draft-clock">
    <img src="../assets/images/logo.png" width="80"><br>

    <div class="end" v-if="isDraftComplete">
      <h5>Draft is complete!</h5>
    </div>

    <div class="display" v-else>
      <h5>{{ roundPickDisplay }}</h5>

      <div class="time" v-if="showClock">
        <div class="minutes">{{ minutes }}</div>
        <div>:</div>
        <div class="seconds">{{ seconds }}</div>
      </div>

      <div class="invite" v-else>
        <p>Join the league</p>
        <div class="">
          Invite code: {{ draft.code }}
        </div>
      </div>

      <div class="progress">
        <div :class="['bar', { warning }]" :style="{ width: `${percentage}%` }" />
      </div>

      <div class="team">
        <div class="name">{{ draftingTeam.name }}</div>

        <div class="team-stats">
          <div class="previous-pick" v-if="previousPickForDraftingTeam">
            <b>Previous pick:</b> {{ previousPickForDraftingTeam }}
          </div>

          <div class="next-pick" v-if="picksAwayForDraftingTeam">
            <b>Picks away:</b> {{ picksAwayForDraftingTeam }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import timer from '@/mixins/timer';

export default {
  mixins: [timer],

  computed: {
    ...mapState({
      draft: ({ draft }) => draft.draft,
      status: ({ draft }) => draft.draft.status,
      endTime: ({ draft }) => draft.draft.endTime,
    }),

    ...mapGetters({
      roundPickDisplay: 'draft/roundPickDisplay',
      isDraftComplete: 'draft/isDraftComplete',
      draftingTeam: 'draft/draftingTeam',
      previousPickForDraftingTeam: 'draft/previousPickForDraftingTeam',
      picksAwayForDraftingTeam: 'draft/picksAwayForDraftingTeam',
    }),

    minutes() {
      const minutes = Math.floor((this.timer_remaining / 1000 / 60) % 60);

      return (`0${minutes}`).slice(-2);
    },

    seconds() {
      const seconds = Math.floor((this.timer_remaining / 1000) % 60);

      return (`0${seconds}`).slice(-2);
    },

    percentage() {
      return (this.timer_remaining / (this.draft.duration * 1000)) * 100;
    },

    warning() {
      return this.percentage < 20;
    },

    showClock() {
      return this.status === 'running';
    },
  },

  created() {
    this.tryStartClock();
  },

  watch: {
    endTime() {
      this.tryStartClock();
    },

    status() {
      this.tryStartClock();
    },
  },

  methods: {
    setDefaultTime() {
      this.timer_remaining = this.draft.duration * 1000;
    },

    tryStartClock() {
      if (this.endTime && this.status === 'running') {
        this.timer_start(this.endTime, this.draft.duration * 1000);
      } else {
        this.timer_stop();
      }
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-clock {
    color: $white-color;
    padding: $gp * 2;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    h3 {
      font-size: px-to-rem(24px);
    }
  }

  .time {
    font-size: px-to-rem(64px);
    margin-bottom: $gp / 2;
    display: flex;
    align-items: center;
    justify-content: center;

    .minutes,
    .seconds {
      width: px-to-rem(78px);
      text-align: left;
    }
  }

  .invite {
    font-size: 44px;
    margin-bottom: $gp;
  }

  .progress {
    background-color: $black-color;
    padding: 4px;
    border-radius: px-to-rem(6px);
    overflow: hidden;
    width: 100%;
    max-width: px-to-rem(400px);
  }

  .bar {
    height: px-to-rem(8px);
    background-color: $primary-color;
    border-radius: px-to-rem(6px);

    &.warning {
      background-color: $error-color;
    }
  }

  .team {
    margin-top: $gp;
    text-align: left;
    display: flex;
    text-align: left;
    flex-direction: column;
    align-items: center;

    .name {
      font-size: px-to-rem(24px);
      margin-bottom: $gp / 2;
      text-align: center;
    }

    .team-stats {
      display: inline-block;
    }
  }
</style>
